import React from 'react';
import type { Recht } from '../berechtigungen';
import { useBerechtigung } from '../berechtigungen/useBerechtigung';
import { APP_ROLLEN_LABEL, rollenMitRecht } from '../verwaltung/rollen';

/**
 * "Rolle Mitarbeit, Marketing, Vertrieb oder Inhaber:in" -- aus der
 * Rollen-Matrix abgeleitet, nicht je Seite von Hand geschrieben.
 */
export function rollenOder(recht: Recht): string {
  const labels = rollenMitRecht(recht).map((r) => APP_ROLLEN_LABEL[r].label);
  if (labels.length === 0) return 'Plattform-Administration';
  if (labels.length === 1) return `Rolle ${labels[0]}`;
  return `Rolle ${labels.slice(0, -1).join(', ')} oder ${labels[labels.length - 1]}`;
}

/**
 * Leise Zeile fuer Lesende (Welle 2): Knoepfe ohne Recht sind ausgeblendet
 * (Paket 2), diese Zeile sagt, wer sie sieht. Ohne Text, solange die Person
 * das Recht hat.
 */
export const RechteHinweis: React.FC<{ recht?: Recht; was?: string; className?: string }> = ({
  recht = 'vertrieb.bearbeiten',
  was = 'Anlegen und Bearbeiten',
  className = 'inbox-item-hinweis',
}) => {
  const { darf } = useBerechtigung();
  if (darf(recht)) return null;
  return <p className={className} data-testid="rechte-hinweis">{was}: {rollenOder(recht)}.</p>;
};

export default RechteHinweis;
